import { isEmpty } from 'lodash';
import customMapBoxGL from './customMapBoxGL';
import adaptURL from '../adapt-url';

import * as layerOps from '../../api/Layers/layer-operations';
import * as styleOps from '../../api/Styles/style-operations';

/**
 * Builds the MapBox GL layer for the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.layer - The layer object.
 * @param {object} arg.style - The style object.
 * @param {number} [arg.zIndex = 10] - The zIndex for the layer.
 * @returns {object} The leaflet layer to add to the map.
 */
const buildMapBoxGLLayer = ({ layer, style, zIndex = 10 }) => {
  const accessToken = layerOps.getAccessToken(layer);

  if (accessToken && !isEmpty(accessToken) && accessToken !== 'no-token') {
    return customMapBoxGL({
      accessToken,
      style: adaptURL(layerOps.getURL(layer)),
      opacity: styleOps.getRasterOpacityPercentage(style) / 100,
      pane: `${zIndex}`,
      attribution: layerOps.getAttribution(layer),
      interactive: true,
      trackResize: false,
      attributionControl: false,
      preferCanvas: true,
      collectResourceTiming: false
    });
  }
  return customMapBoxGL({
    style: adaptURL(layerOps.getURL(layer)),
    opacity: styleOps.getRasterOpacityPercentage(style) / 100,
    pane: `${zIndex}`,
    attribution: layerOps.getAttribution(layer),
    interactive: true,
    trackResize: false,
    attributionControl: false,
    preferCanvas: true,
    collectResourceTiming: false
  });
};

export default buildMapBoxGLLayer;

// const options = {
//   rendererFactory: L.canvas.tile,
//   attribution: layerOps.getAttribution(layer),
//   subdomains: layerOps.getSubdomains(layer), // 01234 for openmaptiles, abcd for mapbox
//   maxNativeZoom: layerOps.getMaxZoom(layer),
//   maxZoom: layerOps.getMaxZoom(layer), // max zoom to preserve detail on; can't be higher than 24
//   tolerance: styleOps.getTolerance(style), // simplification tolerance (higher means simpler)
//   extent: 4096, // tile extent (both width and height)
//   buffer: 640, // tile buffer on each side
//   debug: 0, // logging level (0 to disable, 1 or 2)
//   lineMetrics: false, // whether to enable line metrics tracking for LineString/MultiLineString features
//   promoteId: null, // name of a feature property to promote to feature.id. Cannot be used with `generateId`
//   generateId: false, // whether to generate feature ids. Cannot be used with `promoteId`
//   indexMaxZoom: 5, // max zoom in the initial tile index
//   indexMaxPoints: 1000, // max number of points per tile in the index
//   interactive: true,
//   vectorTileLayerStyles,
//   getFeatureId: feature => {
//     if (!feature.properties.uuid) set(feature, ['properties', 'uuid'], uuid());
//     return feature.properties.uuid;
//   }
// };
